function t(n) {
  return !!(n && n.__CANCEL__);
}
export {
  t as default
};
